<section class="section-pd register-form">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="trinka-title mb-0 text-center ">
                    <h1 class="mb-4">Enterprise Inquiry</h1>
                    <p>Share your requirements with us and our team will reach out to you soon.</p>
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-lg-7 col-md-7 dflex">
                <div class="c-card enterpriseFormCard">
                    <div class="form-wrapper" *ngIf="formSection">
                        <form [formGroup]="contactForm" (ngSubmit)="sendContactUsForm()">
                            <div class="row">
                                <div class="col-12">
                                    <h5 class="md-title md-title1 mt-0">Personal Details</h5>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group w-100" >
                                        <mat-form-field appearance="outline">
                                            <mat-label>Name*</mat-label>
                                            <input matInput placeholder="" formControlName="contactFormName" class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group w-100" >
                                        <mat-form-field appearance="outline">
                                            <mat-label>Email*</mat-label>
                                            <input matInput placeholder="" formControlName="contactFormEmail" class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group w-100" >
                                        <mat-form-field appearance="outline">
                                            <mat-label>Contact Number* (incl. ISD code)</mat-label>
                                            <input type="number" matInput placeholder="" formControlName="contactphoneNo" class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group w-100" >
                                        <mat-form-field appearance="outline">
                                            <mat-label>Designation*</mat-label>
                                            <input matInput placeholder="" formControlName="DesignationTypes" class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <!-- <div class="col-md-12">
                                    <div class="form-group w-100" >
                                        <mat-form-field appearance="outline">
                                            <mat-label>Nature of business*</mat-label>
                                            <input matInput placeholder="" formControlName="NatureBusinessType" class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div> -->
                                <div class="col-md-12">
                                    <div class="form-group w-100" >
                                        <mat-form-field appearance="outline">
                                            <mat-label>Organization name*</mat-label>
                                            <input matInput placeholder="" formControlName="contactFormSubjects" class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <h5 class="md-title md-title1">Requirement Details</h5>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group w-100" >
                                        <mat-form-field appearance="outline">
                                            <mat-label>Count of Users</mat-label>
                                            <input matInput placeholder="" formControlName="countUsers" class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group w-100" >
                                        <mat-form-field appearance="outline">
                                            <mat-label>Monthly File Count/Volume</mat-label>
                                            <input matInput placeholder="" formControlName="monthlyCountVolume" class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <h5 class="md-title">Which features or solutions are you interested in? <small class="d-block">(select all that apply)</small></h5>
                                </div>
                                <div class="col-sm-12 col-12">
                                    <div class="featuresBox mt-3">
                                        <ul>
                                            <li *ngFor="let feature of forIntegration">
                                              <mat-checkbox
                                                [checked]="isSelected('integrationFeatures', feature)"
                                                (change)="toggleFeature('integrationFeatures', feature, $event.checked)">
                                                {{ feature }}
                                              </mat-checkbox>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <!-- <div class="col-sm-6 col-12">
                                    <div class="featuresBox">
                                        <h3>Bulk Licenses</h3>
                                        <ul>
                                            <li *ngFor="let feature of forBulkLicenses">
                                              <mat-checkbox
                                                [checked]="isSelected('bulkLicensesFeatures', feature)"
                                                (change)="toggleFeature('bulkLicensesFeatures', feature, $event.checked)">
                                                {{ feature }}
                                              </mat-checkbox>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-sm-6 col-12">
                                    <div class="featuresBox">
                                        <h3>AI Reports</h3>
                                        <ul>
                                            <li *ngFor="let feature of forReportsOnly">
                                                <mat-checkbox
                                                  [checked]="isSelected('reportsFeatures', feature)"
                                                  (change)="toggleFeature('reportsFeatures', feature, $event.checked)">
                                                  {{ feature }}
                                                </mat-checkbox>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-sm-6 col-12">
                                    <div class="featuresBox">
                                        <h3>Miscellanous</h3>
                                        <ul>
                                            <li *ngFor="let feature of forOthers">
                                                <mat-checkbox
                                                  [checked]="isSelected('miscellanousFeatures', feature)"
                                                  (change)="toggleFeature('miscellanousFeatures', feature, $event.checked)">
                                                  {{ feature }}
                                                </mat-checkbox>
                                            </li>
                                        </ul>
                                    </div>
                                </div> -->
                                <!-- <div class="col-md-12">
                                    <div class="form-group select-group">
                                        <mat-form-field>
                                            <mat-label>Inquiry For</mat-label>
                                            <mat-select formControlName="contactFormInquiryFor" multiple>
                                                <mat-option *ngFor="let inquiry of inquiryFor" [value]="inquiry">{{ inquiry }}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div> -->
                                <div class="col-md-12">
                                    <div class="form-group textArea w-100" >
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>Additional Comments</mat-label>
                                            <textarea matInput formControlName="contactFormMessage"></textarea>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <input
                            type="text"
                            formControlName="enterprise_mapping_code"
                            autocomplete="off"
                            tabindex="-1"
                            style="position:absolute;left:-9999px;"
                            />
                            <div class="btn-group justify-content-center">
                                <button type="submit" class="filled-btn" [disabled]="isSubmitting">
                                    <div id="loading"></div>
                                    <span>Submit</span>
                                </button>
                            </div>
                        </form>
                    </div>  
                    <div class="thank_section contact_us_form" *ngIf="thankSection" #thankSectionRef>
                        <div class="form-group">
                            <svg width="90px" height="90px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>checkmark-circle</title> <desc>Created with Sketch Beta.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"> <g id="Icon-Set-Filled" sketch:type="MSLayerGroup" transform="translate(-102.000000, -1141.000000)" fill="#00ab48"> <path d="M124.393,1151.43 C124.393,1151.43 117.335,1163.73 117.213,1163.84 C116.81,1164.22 116.177,1164.2 115.8,1163.8 L111.228,1159.58 C110.85,1159.18 110.871,1158.54 111.274,1158.17 C111.677,1157.79 112.31,1157.81 112.688,1158.21 L116.266,1161.51 L122.661,1150.43 C122.937,1149.96 123.548,1149.79 124.027,1150.07 C124.505,1150.34 124.669,1150.96 124.393,1151.43 L124.393,1151.43 Z M118,1141 C109.164,1141 102,1148.16 102,1157 C102,1165.84 109.164,1173 118,1173 C126.836,1173 134,1165.84 134,1157 C134,1148.16 126.836,1141 118,1141 L118,1141 Z" id="checkmark-circle" sketch:type="MSShapeGroup"> </path> </g> </g> </g></svg>
                            <h2>Thank You!</h2>
                            <p>We will contact you soon.</p>
                        </div>
                    </div>
                </div>
                <p class="tnc-statement">By submitting this form, you agree to our <a href="/termsofservices" class="text-link">Terms and Conditions</a> and <a href="/privacypolicy" class="text-link">Privacy Policy</a>. </p>
            </div>
            <div class="col-lg-5 col-md-5 dflex">
                <div class="c-card enterpriseFormContent list-wrapper-style-2">
                    <div class="enterpriseCard list-wrapper-content-2">
                        <h4>Not an Enterprise or Institution?</h4>
                        <p>Trinka Premium offers advanced writing assistance for individual users and small or growing teams.</p>
                        <a href="/pricing" class="link-text">
                            Explore Trinka Premium Plans
                            <img src="/assets/images/ReadMoreArrow-blue.png" width="14" height="13" alt="icon">
                        </a>
                    </div>
                    <div class="enterpriseCard list-wrapper-content-2">
                        <h4>Bespoke features and solutions to meet the diverse needs of Enterprises and Institutions</h4>
                        <ul class="list-item">
                            <li>Sensitive data management with full data privacy and security compliance.</li>
                            <li>Customize features and pricing for your needs.</li>
                            <li>Seamless integration with API, SDK, and On-premise options.</li>
                            <li>Access exclusive solutions like Academic Integrity Suite, Offline Desktop App, usage analytics and user management, local invoicing, and more.</li>
                            <li>Build custom AI models and applications to own your IP.</li>
                        </ul>
                    </div>
                    <div class="enterpriseCard list-wrapper-content-2">
                        <h4>Preferred by Top Institutions, Publishers, and Enterprises Globally</h4>
                        <ul class="clientLogos">
                            <li>
                                <img src="../../../assets/images/enterprise-form/ieee.png" alt="IEEE" />
                            </li>
                            <li>
                                <img src="../../../assets/images/enterprise-form/royal-chemistry.png" alt="royal society of chemistry" />
                            </li>
                            <li>
                                <img src="../../../assets/images/enterprise-form/cshl.png" alt="CSHL" />
                            </li>
                            <li>
                                <img src="../../../assets/images/enterprise-form/indegene.png" alt="indegene" />
                            </li>
                            <li>
                                <img src="../../../assets/images/enterprise-form/takeda.png" alt="takeda" />
                            </li>
                            <li>
                                <img src="../../../assets/images/enterprise-form/cbua.png" alt="cbua" />
                            </li>
                            <li>
                                <img src="../../../assets/images/enterprise-form/myrma.png" alt="My rma" />
                            </li>
                            <!-- <li>
                                <img src="../../../assets/images/enterprise-form/tata-fintech.png" alt="tata fintech" />
                            </li> -->
                            <li>
                                <img src="../../../assets/images/enterprise-form/jsu.png" alt="JSU" />
                            </li>
                            <li>
                                <img src="../../../assets/images/enterprise-form/university-of-johannesburg.png" alt="university-of-johannesburg" />
                            </li>
                            <!-- <li>
                                <img src="../../../assets/images/enterprise-form/istanbul-univeristy.png" alt="istanbul univeristy" />
                            </li>
                            <li>
                                <img src="../../../assets/images/enterprise-form/indonesia-university.png" alt="indonesia university" />
                            </li> -->
                        </ul>
                    </div>
                    <div class="enterpriseCard list-wrapper-content-2">
                        <h4>Looking for something else?</h4>
                        <a href="/contactus" class="link-text">
                            Contact Support
                            <img src="/assets/images/ReadMoreArrow-blue.png" width="14" height="13" alt="icon">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>